
<template>
  <div class="login">
    <home-header :isShow="false"></home-header>
    <div class="center_bg">

      <div class="login_left">
        <img src="../assets/images/login_bannerimg.png"/>
      </div>

      <div style="flex: 1;"></div>

      <div class="center">
        <div class="frombox" >
          <div
            class="btns"
            style="text-align: center;"
          >
            <el-menu  :default-active="activeIndex" class="el-menu-demo btns" mode="horizontal" @select="handleSelect">
              <el-menu-item class="el-button" index="1">手机号登录</el-menu-item>
              <el-menu-item class="el-button" index="2">微信账号登录</el-menu-item>
            </el-menu>
          </div>

          <div class="sjhForm" v-if="sjhFormShow">
            <el-form :model="form" :rules="rules" ref="form">
              <el-form-item prop="mobile">
                <el-input
                  placeholder="请输入手机号"
                  v-model="form.mobile"
                  clearable
                >
                </el-input>
              </el-form-item>
              <el-form-item  prop="password">
                <el-input
                  placeholder="请输入密码"
                  v-model="form.password"
                  show-password
                  @keyup.enter.native="changeConfirm"
                ></el-input>
              </el-form-item>
            </el-form>

            <div class="links">
              <router-link to="/register"><el-link :underline="false">账号注册</el-link></router-link>
              <router-link  to="/reset"><el-link style="float: right;" :underline="false">忘记密码？</el-link></router-link>
            </div>
            <div class="dl"   @click="changeData('form')">登录</div>
          </div>
          <div class="ewm" v-else>
            <wxlogin class="img"  appid="wx08ce7cf7c8886e10"  :scope="'snsapi_login'"   :theme="'black'"   :redirect_uri='encodeURIComponent(redirect_url)'   :href="'data:text/css;base64,LmV3bSAuaW1newogIHdpZHRoOiA0MDBweDsKICBoZWlnaHQ6IDMwMHB4OwogIG1hcmdpbjogMCBhdXRvOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMjBweDt9Ci5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9'" rel="external nofollow">
            </wxlogin>
          </div>
        </div>
      </div>

    </div>
    <login-footer></login-footer>

  </div>

</template>
<script>
    import qrcode from './qrcode'
    import wxlogin from 'vue-wxlogin';
    import api from '@/request/api';
    import HomeHeader from '@/components/homeHeader'
    import LoginFooter from '@/components/LoginFooter'
    import { mapMutations } from 'vuex'
    export default {
        name: 'Login',
        components: {
            qrcode,
            wxlogin,
            HomeHeader,
            LoginFooter
        },
        data () {
            // 手机验证
            var validateMobilePhone = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("手机号不可为空"));
                } else {
                    if (value !== "") {
                        var reg = /^1[3456789]\d{9}$/;
                        if (!reg.test(value)) {
                            callback(new Error("请输入有效的手机号码"));
                        }
                    }
                    callback();
                }
            };
            // 密码验证
            var validatePass = (rule, value, callback) => {
                const pwdReg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;
                if (!value) {
                    return callback(new Error("请输入密码"));
                } else if (pwdReg.test(value)) {
                    callback();
                } else {
                    callback(new Error("请输入包含数字字母的不低于8位数的密码"));
                }
            };

            return {
                rules: {
                    mobile: [
                        {
                            required: true,
                            validator: validateMobilePhone,
                            trigger: "change",
                        },
                    ],
                    password: [
                        { required: true, validator: validatePass, trigger: "change" },
                    ],

                },
                activeIndex: '1',
                sjhFormShow:true,
                form: {
                    mobile: '',
                    password: '',
                },
                code:'',
                redirect_url:window.location.href
            }
        },
        methods: {
          ...mapMutations('user',['setUserInfo']),
          changeConfirm(e){
            // alert('111')
            // console.log('-------',e);
            this.changeData('form')
          },
            //完成
            changeData(form){
                this.$refs[form].validate((valid) => {
                    console.log(valid)
                    if (valid) {
                        this.doLogin ()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            //重置
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },

            handleSelect(key, keyPath) {
              if(key == 1){
                this.sjhFormShow = true
              }else{
                this.sjhFormShow = false
              }
            },
            doLogin () {
                var data = {
                    username:this.$data.form.mobile,
                    password:this.$data.form.password,
                    group: 'pc'
                }
                this.$api.login(data).then(res => {
                    //数据处理
                    this.$message.success('登录成功')
                    console.log(res.data.member)
                    sessionStorage.setItem('token',res.data.access_token)
                    sessionStorage.setItem('user',JSON.stringify(res.data.member))
                    localStorage.setItem('token',res.data.access_token);
                    localStorage.setItem('user',JSON.stringify(res.data.member))

                    this.setUserInfo(res.data.member)
                    
                    let ogran_id = localStorage.getItem('ogran_id');
                    if(+ogran_id === 320){
                      // 中科院
                      this.$router.replace({
                        path:'/details/426',
                      })
                    }else{
                      let redirect  =  this.$route.query.redirect?this.$route.query.redirect:'/'
                      this.$router.replace({
                          path: redirect
                      });
                    }
                }).catch(err => console.log(err))
            },
            message () {
                console.log( window.location.host+this.$route.path)
                // this.$api.messageList().then(res => {
                //     //数据处理
                // }).catch(err => console.log(err))
            },

        },

        watch: {
            $route: {
                handler() {
                    this.code = this.$route.query.code;
                    console.log(this.code)

                    if(this.code){
                        api.wechatLogin({code:this.code}).then(res=>{
                            //数据处理
                            if(res.data.member.mobile){
                                this.$message.success('登录成功')
                                sessionStorage.setItem('token',res.data.access_token)
                                sessionStorage.setItem('user',JSON.stringify(res.data.member))
                                // 使用localstorage
                                localStorage.setItem('token',res.data.access_token);
                                localStorage.setItem('user',JSON.stringify(res.data.member))
                                //
                                let ogran_id = localStorage.getItem('ogran_id')

                                
                                let redirect  =  this.$route.query.redirect?this.$route.query.redirect:'/'
                                if(+ogran_id === 320){
                                  redirect = `/details/426`;
                                }else{
                                  
                                }
                                this.$router.replace({
                                    path: redirect
                                });
                            }else{
                                this.$message.info('请绑定手机号')
                                this.$router.push({
                                    name: 'BindPhone',
                                    params: {
                                        token: res.data.access_token
                                    }
                                })
                            }

                            console.log(res)
                        }).catch(err => console.log(err))
                    }
                    //深度监听，同时也可监听到param参数变化
                },
                deep: true,
            }
        },
        created(){
          // mock/
          // let ogran_id = localStorage.getItem('ogran_id')
          // if(+ogran_id === 320){
          //   this.redirect_url = `https://www.yulin365.net/#/details/426?ogran=320`
          // }else{
          //   this.redirect_url = window.location.href
          // }

          // mock
          // this.form = {
          //   mobile: '18326360002',
          //   password: 'yl123456'
          // }
        }
    }

</script>

<style scoped>
.login {
  width: 100%;
  position: relative;
}
.center_bg{
  width: 100%;
  height: 510px;
  background: linear-gradient(180deg,  #2e92fe,#3370ff);

  background-size: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 400px;
  box-sizing: border-box;
}
.title {
  text-align: center;
}
.title div{
  height: 40px;
  font-size: 40px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 20px;
}
.title span {
  width: 153px;
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.frombox {
  background: #ffffff;
  border-radius: 10px;
  padding: 60px 30px;
  box-sizing: border-box;
}
.el-menu--horizontal>.el-menu-item.is-active {
  background: #3370ff !important;
  color: #ffffff !important;
  border-bottom: none;
}
.el-button:focus, .el-button:hover{
  background: none !important;
}
.btns{
  background: #f6f6f6;
  margin: 0px auto;
  display: flex;
}
.el-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #999999;
}
.el-button+.el-button {
  margin: 0px !important;
}
.el-link {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.frombox >>> .el-input__inner {
  border-top: none;
  border-bottom: 1px solid #eeeeee;
  border-left: none;
  border-right: none;
}
.dl {
  background: #3370ff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #ffffff;
  margin: 20px auto 0px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.ewm{
  text-align: center;
  margin-top: 25px;
}
.login_left img{
  width: 350px;
}


@media (min-width: 1024px){
    .center_bg{
      height:620px ;
    }
    .frombox{
      width: 450px;
      height: 500px;
    }
    .btns{
      width: 350px;
      height: 50px;
      border-radius: 25px;
    }
    .el-menu--horizontal > .el-menu-item { 
      height: auto !important;
    }
    .el-button {
        width: 400px;
        height: 50px;
        border-radius: 25px;
    }
    .el-form,
    .links {
      width: 350px;
      margin: 50px auto;
    }
    .dl {
      width: 350px;
      height: 50px;
      border-radius: 25px;
    }
    .el-form-item {
      margin-bottom: 30px;
    }
    
    } /*>=1024的设备*/

    @media (min-width: 1080px) {
      .frombox{
        height: 550px;
      }
    } /*>=1080的设备*/
    @media (min-width: 1280px) {
      .center_bg{
        height:510px ;
      }
      .frombox{
        width: 400px;
        height: 480px;
      }
      .btns{
        width: 300px;
        height: 40px;
        border-radius: 20px;
      }
      .el-menu--horizontal > .el-menu-item { 
          height: auto !important;
      }
      .el-button {
        width: 300px;
        height: 40px;
        border-radius: 20px;
      }
      .el-form,
    .links {
      width: 300px;
      margin: 40px auto;
    }
    .dl {
      width: 300px;
      height: 40px;
      border-radius: 20px;
         
    }
    .el-form-item {
  margin-bottom: 20px;
}
    } /*>=1280的设备*/


</style>



// WEBPACK FOOTER //
// src/login/Login.vue